import { NationalMenuTileData } from './types';

const drinks: Array<NationalMenuTileData> = [
  {
    id: 'drink1',
    name: 'Pepsi®',
    mobileImageUrl: '/images/nationalMenu/drinks/National_Drinks_Pepsi.png',
    desktopImageUrl: '/images/nationalMenu/drinks/National_Drinks_Pepsi.png',
    productDescription: 'The bold, refreshing, robust cola. All that\'s missing are the classic Pizza Hut cups.',
    priority: 0,
    vegetarian: false,
    handleClick: undefined
  },
  {
    id: 'drink2',
    name: 'Diet Pepsi®',
    mobileImageUrl: '/images/nationalMenu/drinks/National_Drinks_DietPepsi.png',
    desktopImageUrl: '/images/nationalMenu/drinks/National_Drinks_DietPepsi.png',
    productDescription: 'Light. Crisp. Refreshing. With zero sugar, zero calories, and zero carbs. You know what that means? More pizza.',
    priority: 1,
    vegetarian: false,
    handleClick: undefined
  },
  {
    id: 'drink3',
    name: 'Mtn Dew®',
    mobileImageUrl: '/images/nationalMenu/drinks/National_Drinks_MtnDew.jpg',
    desktopImageUrl: '/images/nationalMenu/drinks/National_Drinks_MtnDew.jpg',
    productDescription: 'Mountain Dew, the original instigator, refreshes with its one of a kind great taste.',
    priority: 2,
    vegetarian: false,
    handleClick: undefined
  },
  {
    id: 'drink4',
    name: 'Starry®',
    mobileImageUrl: '/images/nationalMenu/drinks/National_Drinks_Starry.jpg',
    desktopImageUrl: '/images/nationalMenu/drinks/National_Drinks_Starry.jpg',
    productDescription: 'Starry is a crisp, clear, refreshing, lemon lime soda that’s caffeine free and bursting with flavor.',
    priority: 3,
    vegetarian: false,
    handleClick: undefined
  }
];

export default drinks;
